webpackJsonp([75439440871930],{

/***/ 936:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0009_charge.jpg","type":"Minor Spell","subtype":"Buff","cost":2,"ATK":null,"HP":null,"rules_text_1":"Give one of your units haste and +1 ATK this turn.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Charge","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":null,"bottom":"Magic","rulings":[],"keywords":["Haste"],"slug":"charge"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"charge","keywords":["Haste"],"imageRegex":"/charge.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-charge-31a2e326229c1d2a0eae.js